const formatTime = (totalMinutes: number): string => {
  const normalizedMinutes = totalMinutes % (24 * 60);
  const hour = String(Math.floor(normalizedMinutes / 60)).padStart(2, "0");
  const minute = String(normalizedMinutes % 60).padStart(2, "0");
  return `${hour}.${minute}`;
};

const formatTimeRange = (time: string, durationMinutes = 60): string => {
  const match = time.trim().match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return time;

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour > 23 || minute > 59 || durationMinutes < 0) return time;

  const startMinutes = hour * 60 + minute;
  return `${formatTime(startMinutes)}-${formatTime(
    startMinutes + durationMinutes
  )}`;
};

export default formatTimeRange;
